// extracted by mini-css-extract-plugin
export default {"fullPage":"src-hellospa-page-prep-and-send-data-types-workflow__fullPage--3SG_f"};